import { Component } from '@angular/core';
import { I18nKeys } from '../../shared/models/i18n.model';

@Component({
	selector: 'app-error-callback-creation',
	standalone: false,
	templateUrl: './error-callback-creation.html',
	styleUrl: './error-callback-creation.scss',
})
export class ErrorCallbackCreation {
	protected readonly I18N = I18nKeys;
}
